export default "__VITE_ASSET__gdDSG6kg__"